import { CreateClicksignSignature } from '@/features/privateCompanyLeadsFunnel/components/ContractSignatureDetails/ClicksignSignature/Create'
import { ShowClicksignSignature } from '@/features/privateCompanyLeadsFunnel/components/ContractSignatureDetails/ClicksignSignature/Show'
import { usePrivateCompanyLeadContractEnvelope } from '@/features/privateCompanyLeadsFunnel/hooks/usePrivateCompanyLeadContractEnvelope'
import { PrivateCompanyLeadData } from '@/features/privateCompanyLeadsFunnel/types/privateCompanyLead'

interface ClicksignSignatureProps {
  privateCompanyLead: PrivateCompanyLeadData
  disableFields?: boolean
}

export const ClicksignSignature = ({ privateCompanyLead, disableFields }: ClicksignSignatureProps) => {
  const { data: contractEnvelopeData, isPending: contractEnvelopeDataIsPending } =
    usePrivateCompanyLeadContractEnvelope({ privateCompanyLeadId: privateCompanyLead.id })

  return (
    <>
      {contractEnvelopeData?.status === 'draft' ? (
        <CreateClicksignSignature
          privateCompanyLead={privateCompanyLead}
          contractEnvelope={contractEnvelopeData}
          contractEnvelopeIsPending={contractEnvelopeDataIsPending}
          disableFields={disableFields}
        />
      ) : (
        <ShowClicksignSignature
          privateCompanyLead={privateCompanyLead}
          contractEnvelope={contractEnvelopeData}
          contractEnvelopeIsLoading={contractEnvelopeDataIsPending}
          disableFields={disableFields}
        />
      )}
    </>
  )
}
